import { Policy } from '../../controllers';

export type { Policy };
export interface PolicyValidator {
    validate(policy: Policy): boolean;
}

export const checkLicense = (policy: Policy, license: string): boolean => {
    return policy?.licenseAndScope?.[license] !== undefined;
};

export const checkScope = (policy: Policy, licensePlusScope: string): boolean => {
    const [license, scope] = licensePlusScope.split(':');
    if (!scope) return checkLicense(policy, license);
    return policy?.licenseAndScope?.[license]?.includes(scope) || false;
};
